import React from 'react';
import { CardView } from 'design-system';
import Text from 'design-system/Text';
const EmptyAutosaveActivity = () => (<CardView noMarginTop noMarginBottom withPadding>
    <Text TextThin-14 Secondary>
      Here you will see past payments and the upcoming payment 24 hours before it’s due.
    </Text>
  </CardView>);
export default EmptyAutosaveActivity;
